import axios from "axios";
import { gapi } from "./api.js";
import str from "../index.js";

const url = gapi + "users";


const users = {
  namespaced: true,
  state: {
    userAll: [],
    roleName:'',       
  },
  getters: {
    GET_ALLDATA: (state) => {
      return state.userAll;
    },
    getTodoById: (state) => (id) => {
      return state.userAll.find((todo) => todo.id == id);
    },
  },
  mutations: {
    SET_DATA(state, data) {
      state.userAll = data;
    },

    ADD_DATA(state, data) {
        this.roleName = str.state.roles.find((todo) => todo.id == data.role);
        data.roleN = this.roleName.roleName;
      state.userAll.unshift(data);
    },
  
    UPDATE_DATA(state, data) { 
      const index = state.userAll.findIndex((t) => t.id === data.id);

      this.roleName = str.state.roles.find((todo) => todo.id == data.role);

      var dts = {
               id : data.id,
               busSeats: data.busSeats,
               boardNum: data.boardNum,
               name : data.name,
               email : data.email,
               password : data.password,
               role : data.role,
               roleN : this.roleName.roleName
              
                     }
      if (index !== -1) {
        state.userAll.splice(index, 1, dts);
      }
    },
    DELETE_DATA(state, data) {
      state.userAll = state.userAll.filter((t) => data.id !== t.id);
    },
  },
  actions: {

    async fetchData({ commit }) {
      await axios
        .get(url,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("SET_DATA", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    }, // get all data view with reletion
  
    // add student
    async addData({ commit }, data) {
      var ddd = str.state.token;
      console.log(ddd);
      await axios
        .post(url, data,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("ADD_DATA", res.data.data);
        })
        .catch((error) => console.log(error));
    },
    // get student to edit
    async getData(id) {
      await axios
        .get(url + "/" + id,{headers:{Authorization: str.state.token}})
        .then((res) => {
          return res.data.data;

        })
        .catch((error) => console.log(error));
    },
    // update student
    async updateData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .put(app, data,{headers:{Authorization: str.state.token}})
        .then(
          commit("UPDATE_DATA", data)

        )
        .catch((error) => console.log(error));
    },

    async deleteData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .delete(app,{headers:{Authorization: str.state.token}})
        .then(
          commit("DELETE_DATA", data)
 
        )
        .catch((error) => console.log(error));
    },
  },
};
export default users;
